<icon>
  <template if={this.png()}>
    <img src={this.url()} />
  </template>
  <template if={props.type == 'arrow-right'}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="16"
      viewBox="0 0 19 16"
    >
    <polygon class="cls-1" points="11.08 -0.13 10.37 0.58 16.79 7 0 7 0 8 16.79 8 10.37 14.42 11.08 15.13 18.71 7.5 11.08 -0.13"></polygon>
    </svg>
  </template>
  <template if={props.type == 'arrow-left'}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="16"
      viewBox="0 0 19 16"
    >
      <polygon class="cls-1" points="11.08 -0.13 10.37 0.58 16.79 7 0 7 0 8 16.79 8 10.37 14.42 11.08 15.13 18.71 7.5 11.08 -0.13" transform="translate(19) scale(-1, 1)"></polygon>
    </svg>
  </template>
  <template if={props.type == 'arrow-up'}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="27"
      viewBox="0 0 22 27"
    >
      <path class="cls-1" d="M21.96 11.55l-10.96-10.95-10.96 10.95 1.42 1.42 8.54-8.55v22.58h2v-22.58l8.54 8.55 1.42-1.42z"></path>
    </svg>
  </template>
  <template if={props.type == 'cross'}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '32'}
      height={props.height || '32'}
      viewBox="0 0 32 32"
    >
      <path class="cls-1" d="M30 31.41l-14-14-14 14-1.41-1.41 14-14-14-14 1.41-1.41 14 14 14-14 1.41 1.41-14 14 14 14-1.41 1.41z"></path>
    </svg>
  </template>
  <template if={props.type == 'chevron-left'}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="42"
      viewBox="0 0 18 42"
    >
      <path class="cls-1" d="M16.22 41.63l-16.5-20.63 16.5-20.62 1.56 1.25-15.5 19.37 15.5 19.38-1.56 1.25z"></path>
    </svg>
  </template>
  <template if={props.type == 'chevron-right'}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="42"
      viewBox="0 0 18 42"
    >
      <path class="cls-1" d="M1.78 41.63l-1.56-1.25 15.5-19.38-15.5-19.37 1.56-1.25 16.5 20.62-16.5 20.63z"></path>
    </svg>
  </template>
  <template if={props.type == 'triangle-down'}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
  </template>
  <template if={props.type == 'triangle-up'}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <polyline points="18 15 12 9 6 15"></polyline>
    </svg>
  </template>
  <template if={props.type == 'tbs-arrow-down'}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1" />
    </svg>
  </template>
  <template if={props.type == 'tbs-arrow-up'}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5" />
    </svg>
  </template>
  <template if={props.type == 'print'}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <path class="cls-1" d="M12 4h-6v1h6zm0-2h-6v1h6zm0 4h-6v1h6zm-6 3h6v-1h-6zm-2-8h10v8h1v-9h-12v9h1zm12 9h-14a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm-1 4h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2z"></path>
    </svg>
  </template>
  <template if={props.type == 'download'}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
    >
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
      <polyline points="7 10 12 15 17 10"></polyline>
      <line x1="12" y1="15" x2="12" y2="3"></line>
    </svg>
  </template>
  <template if={props.type == 'book'}>
    <svg
      width="23.5"
      height="18"
      viewBox="0 0 135.46121 103.24776"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        style="fill:#000000"
        d="m 128.19062,102.92344 c -13.11949,-2.59521 -23.0536,-3.465374 -33.389171,-2.924644 -5.16469,0.270194 -11.75602,1.095384 -15.02215,1.880654 -0.578,0.13897 -1.08918,0.21439 -1.13597,0.1676 -0.17307,-0.17307 2.51882,-2.364614 4.63468,-3.773244 7.59537,-5.05655 17.416441,-7.86568 29.434491,-8.41916 5.61614,-0.25865 7.9971,-1.0896 10.66857,-3.72333 1.48164,-1.46072 2.35972,-2.88244 3.08853,-5.00075 0.51918,-1.50905 0.53039,-2.20635 0.53039,-32.98563 V 16.700941 l 2.31511,0.0058 c 3.35796,0.0084 4.82306,0.766392 5.74459,2.971935 0.36014,0.86193 0.4063,5.50391 0.40116,40.33928 -0.006,37.61949 -0.0274,39.41268 -0.49152,40.434544 -0.4306,0.94797 -1.88736,2.49191 -2.36724,2.50891 -0.098,0.003 -0.59486,0.10233 -1.10418,0.21969 -0.61807,0.14241 -1.71797,0.0567 -3.30729,-0.25767 z M 2.778125,102.84624 C 1.755686,102.39182 0.924075,101.47961 0.409503,100.24806 0.046123,99.378376 0,94.840656 0,59.960366 0,25.185636 0.04693,20.540426 0.406966,19.678736 1.328501,17.473193 2.793604,16.715231 6.151562,16.706801 l 2.315104,-0.0058 v 31.443995 c 0,30.77928 0.01121,31.47658 0.5304,32.98563 0.728805,2.11831 1.60688,3.54003 3.088526,5.00075 2.671466,2.63373 5.052426,3.46468 10.668574,3.72333 11.740162,0.54068 21.534449,3.28003 28.971873,8.1031 1.8747,1.21572 5.268187,3.919584 5.112033,4.073164 -0.04672,0.046 -1.156512,-0.137 -2.4662,-0.40656 -4.386373,-0.90279 -7.897079,-1.31879 -13.706657,-1.62415 -10.021728,-0.526744 -21.518101,0.43909 -32.127787,2.69914 -2.821368,0.601 -4.633535,0.6472 -5.759303,0.14685 z m 60.192704,-5.587774 c -1.4446,-1.50319 -5.261373,-4.47278 -7.785974,-6.05777 -8.297619,-5.20941 -19.173835,-8.31808 -30.710898,-8.7779 -2.182812,-0.087 -4.40982,-0.26843 -4.948907,-0.4032 -1.295798,-0.32393 -2.553469,-1.41445 -3.152723,-2.7337 -0.463739,-1.02092 -0.485969,-2.74799 -0.491517,-38.18559 -0.0063,-40.30173638 -0.08314,-38.1164784 1.39588,-39.7005304 1.148547,-1.23010898 1.920922,-1.43565798 5.242411,-1.39513798 11.113786,0.13558 21.77352,3.15558798 29.728683,8.42243098 4.837568,3.2027884 10.776955,9.8109294 11.513535,12.8099174 0.19615,0.79861 0.26043,12.79616 0.20932,39.06881 l -0.0738,37.91627 z m 8.46814,-37.04256 c 0.001,-26.78295 0.0875,-38.40077 0.29122,-39.13456 0.82689,-2.97832 6.7832,-9.538936 11.48869,-12.6542774 7.95516,-5.266843 18.614891,-8.28685098 29.728681,-8.42243098 3.32149,-0.04052 4.09386,0.165029 5.24241,1.39513798 1.47902,1.584052 1.40219,-0.60120598 1.39588,39.7005304 -0.006,35.4376 -0.0278,37.16467 -0.49151,38.18559 -0.59926,1.31925 -1.85693,2.40977 -3.15273,2.7337 -0.53909,0.13477 -2.76609,0.31621 -4.94891,0.4032 -15.404701,0.61396 -29.171371,5.85971 -38.166141,14.5431 l -1.38906,1.34097 0.002,-38.09096 z"
      />
    </svg>
  </template>
  <template if={props.type == 'quotes'}>
    <svg
      width="23.643023"
      height="18.061821"
      viewBox="0 0 6.255555 4.7788569"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        style="fill:#000000"
        d="M 0.839441,4.6839607 C 0.584893,4.5657398 0.4457352,4.4332934 0.286327,4.1575228 0.096079,3.8284002 0,3.4319636 0,2.9760936 0,1.9614137 0.4865367,1.0374537 1.4376383,0.24593886 1.601209,0.10981394 1.7510215,-8.5318e-4 1.7705549,1.207e-5 c 0.019534,8.6526e-4 0.115073,0.1071168 0.2123106,0.23611477 L 2.1596609,0.47066842 1.9828655,0.60339892 C 1.6234608,0.87322462 1.285046,1.2250445 1.1583731,1.4605507 1.0202005,1.7174366 0.8314045,2.2713076 0.8691477,2.3090509 0.8815021,2.321405 1.0041577,2.3075093 1.1417163,2.2781704 1.9618781,2.1032469 2.6059375,2.7551567 2.5313216,3.6847135 2.4910874,4.1859461 2.2621977,4.5383491 1.8706037,4.7019674 1.6100904,4.8108171 1.0931445,4.8017895 0.839441,4.6839607 Z m 3.7110511,7.884e-4 C 4.2843821,4.5638804 3.998763,4.2279508 3.8569046,3.8689915 3.7650422,3.6365421 3.7442397,3.4791943 3.7420284,3.0000761 3.7388788,2.3178422 3.8426543,1.9116611 4.1574163,1.3742201 4.3749594,1.0027756 4.9124447,0.41013322 5.2546696,0.16436591 L 5.483545,0 5.667097,0.2240012 c 0.1009539,0.12320052 0.1835522,0.23394122 0.1835522,0.24609042 0,0.012149 -0.1391265,0.1313934 -0.3091701,0.2649873 C 5.1451545,1.046449 4.8689607,1.3976331 4.731537,1.764931 4.6000586,2.1163385 4.5457405,2.3650766 4.6089839,2.3261359 4.7427199,2.2437912 5.2077747,2.2351071 5.4658627,2.3101351 6.4296162,2.590306 6.543914,4.2672708 5.6276168,4.6833779 5.3485206,4.8101208 4.827968,4.8107847 4.5504921,4.6847456 Z"
      />
    </svg>
  </template>
  <template if={props.type == 'braces'}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.5"
      height="18"
      fill="currentColor"
      class="bi bi-braces"
      viewBox="0 0 16 16"
    >
      <path d="M2.114 8.063V7.9c1.005-.102 1.497-.615 1.497-1.6V4.503c0-1.094.39-1.538 1.354-1.538h.273V2h-.376C3.25 2 2.49 2.759 2.49 4.352v1.524c0 1.094-.376 1.456-1.49 1.456v1.299c1.114 0 1.49.362 1.49 1.456v1.524c0 1.593.759 2.352 2.372 2.352h.376v-.964h-.273c-.964 0-1.354-.444-1.354-1.538V9.663c0-.984-.492-1.497-1.497-1.6zM13.886 7.9v.163c-1.005.103-1.497.616-1.497 1.6v1.798c0 1.094-.39 1.538-1.354 1.538h-.273v.964h.376c1.613 0 2.372-.759 2.372-2.352v-1.524c0-1.094.376-1.456 1.49-1.456V7.332c-1.114 0-1.49-.362-1.49-1.456V4.352C13.51 2.759 12.75 2 11.138 2h-.376v.964h.273c.964 0 1.354.444 1.354 1.538V6.3c0 .984.492 1.497 1.497 1.6z"/>
    </svg>
  </template>
  <template if={props.type == 'bookmark'}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.5"
      height="18"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M2 2v13.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z"/>
    </svg>
  </template>
  <template if={props.type == 'folder'}>
    <svg 
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1" 
      stroke-linecap="round" 
      stroke-linejoin="round" 
      class="feather feather-folder"
    >
      <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
    </svg>
  </template>
  <template if={props.type == 'folder-filled'}>
    <svg 
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="1" 
      stroke-linecap="round" 
      stroke-linejoin="round" 
      class="feather feather-folder"
    >
      <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
    </svg>
  </template>
  <template if={props.type == 'email'}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="feather feather-mail"
    >
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
      <polyline points="22,6 12,13 2,6"></polyline>
    </svg>
  </template>
  <template if={props.type == 'align-left'}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="feather feather-mail"
    >
      <line x1="17" y1="10" x2="3" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="17" y1="18" x2="3" y2="18"></line>
    </svg>
  </template>
  <template if={props.type == 'external-link'}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="feather feather-external-link"
    >
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
      <polyline points="15 3 21 3 21 9"></polyline>
      <line x1="10" y1="14" x2="21" y2="3"></line>
    </svg>
  </template>

  <script>
    // import DfkFrontend from '../index'

    // const c = DfkFrontend.config()

    export default class {
      png() {
        const pngs = []
        return pngs.includes(this.props.type)
      }

      url() {
        return `${c.staticUrl}/icons/${this.props.type}.png`
      }
    }
  </script>
</icon>
